import { Component } from "@angular/core";

@Component({
  selector: "jni-bac-bas-current-support-table",
  templateUrl: "./bac-bas-current-support-table.component.html",
  styleUrls: ["./bac-bas-current-support-table.component.scss"],
})
export class BacBasCurrentSupportTableComponent {}
